import { Link, useOutletContext } from "react-router-dom";
import { useGetPursuitDocs } from "./useGetPursuitDocs";
import CardLoader from "@/ui/CardLoader";
import ChatAutoStart from "../chat/ChatAutoStart";
import { FileUp, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PursuitChat() {
  const { pursuit } = useOutletContext();

  const { data, isLoading } = useGetPursuitDocs(pursuit.id);

  if (isLoading) {
    return <CardLoader />;
  }
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-4 border border-dashed rounded-lg text-muted-foreground ">
        <MessageSquare className="mx-auto h-8 w-8 stroke-1" />
        <h2 className="mt-4 text-xl font-medium">
          No Documents Available for Chat.
        </h2>
        <p className="text-muted-foreground mt-2">
          Upload your first document to get started
        </p>

        <div className="mt-4">
          <Button>
            <FileUp />
            <Link to={`../documents`}>Upload Document</Link>
          </Button>
        </div>
      </div>
    );
  }
  return (
    <ChatAutoStart
      proposal_id={pursuit?.proposal_id}
      purpose="pursuit-chat"
      searchType={pursuit?.search_type}
      docIds={data.map((doc) => doc.openai_id) || []}
      className="h-[calc(100vh-10rem)]"
      hideCloseButton
    />
  );
}
